import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'snapshots/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('snapshots/', '')
      .toLowerCase();
  }
}
